<template>
  <div>
    <div v-if="loading" style="border: 1px solid #F0F0F0">
      <v-progress-circular :width="2" indeterminate style="color: forestgreen"/>
    </div>
    <div v-else style="border: 1px solid #F0F0F0;">
      <!--Order price only for retoucher role-->
      <div v-if="createFinanceblock" class="uk-padding-xsmall">
        <div class="uk-grid tm-grid-xsmall uk-flex-middle" data-uk-grid>
          <!--стоимость заказа + описание-->
          <div>
            <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
              <div class="uk-text-uppercase">
                {{ local_page_keys.label_order_price }}: {{ finance_info.order_price }} {{ local_page_keys.label_currency_UAH }}
              </div>
              <div>
                <div class="tm-status tm-status-grey" style="padding: 0 5px;cursor: pointer;">
                  <md-icon style="color: #9c27b0;">expand_more</md-icon>
                </div>
                <div style="width:300px; padding: 0;"
                     class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                     data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 400; delay-show: 0; offset: 10">
                  <div class="uk-position-relative uk-position-z-index">
                    <md-table>
                      <md-table-row>
                        <md-table-cell>{{ local_page_keys.label_option_prime_rate }} - {{ finance_info.basic_tarif }}
                          {{ local_page_keys.label_currency_UAH }}
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>{{ local_page_keys.label_option_night_order_surcharge }} -
                          {{ finance_info.night_tarif }} {{ local_page_keys.label_currency_UAH }}
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>{{ local_page_keys.label_option_day_off_order_surcharge }} -
                          {{ finance_info.weekend_tarif }} {{ local_page_keys.label_currency_UAH }}
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell>{{ local_page_keys.label_option_additional_features }} -
                          {{ finance_info.additional_services }} {{ local_page_keys.label_currency_UAH }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Осталось времени-->
          <div v-if="education != 1">
            <div v-if="timerMinutes !== null && minusTimer === null" id="mainTimerDiv" :class="statusClass">
              <p id="timer">
                {{ local_page_keys.timer_left }}:
                <span>{{ timerMinutes }} : {{ timerSeconds >= 10 ? timerSeconds : "0" + timerSeconds }}</span>
              </p>
            </div>
            <div v-if="timerMinutes !== null && minusTimer !== null" id="mainTimerDiv" :class="statusClass">
              <p id="timer">
                {{ local_page_keys.timer_left }}:
                <span>{{ minusTimer }}{{
                    timerMinusMinutes
                  }} : {{ timerMinusSeconds >= 10 ? timerMinusSeconds : "0" + timerMinusSeconds }}</span>
              </p>
            </div>
          </div>
          <!--Заработал сегодня-->
          <div>
            <div class="uk-background-muted uk-padding-xxsmall uk-border-rounded">
              {{ local_page_keys.lable_retoucher_earned_today }}: {{ Number(retoucher_earned_today).toFixed(2) }}
            </div>
            <div style="width:300px" class="uk-dropdown tm-dropdown"
                 data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 400; delay-show: 0; offset: 10">
              {{ local_page_keys.label_retoucher_earned_today_popup }}
            </div>
          </div>
          <!--К выплате-->
          <div>
            <div class="uk-background-muted uk-padding-xxsmall uk-border-rounded">
              {{ local_page_keys.lable_retoucher_earned_and_not_paid_yet }}:
              {{ Number(retoucher_earned_and_not_paid_yet).toFixed(2) }}
            </div>
            <div style="width:300px" class="uk-dropdown tm-dropdown"
                 data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 400; delay-show: 0; offset: 10">
              {{ local_page_keys.label_retoucher_earned_and_not_paid_yet_popup }}
            </div>
          </div>
        </div>
      </div>
      <!--Описание фукнций-->
      <div class="uk-padding-xsmall tm-background-muted 2">
        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div v-if="Object.keys(facesOrderSuperFunction).length > 0">
<!--            <a href="#" @click="info(facesOrderSuperFunction)" :data-uk-tooltip="facesOrderSuperFunction.RU">-->
              <img class="tm-img-icon" :src="facesOrderSuperFunction.icon" width="30" height="30" alt="">
<!--            </a>-->
          </div>
          <div>
            {{ local_page_keys.label_ordering_instructions }}:
          </div>
        </div>
      </div>
      <div>
        <!--список-->
        <div v-if="faces !== null" class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-info-list" data-uk-grid>
          <!--общее-->
          <div class="uk-transition-toggle" v-for="(value, name) in  faces" :key="value.worker">
            <div class="uk-padding-small" v-if="name === 0">{{ local_page_keys.label_instructions_general }}</div>
            <div class="uk-padding-small" v-else-if="getFaceInfo(name).deleted_at === null">
              <div class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
                <div v-html="getFaceName(name)"></div>
                <div>
<!--                  <img class="tm-img-icon tm-img-part" src="/img/icons/Users_group.svg" width="30" height="30" alt="" @click="showPhotoDialog()" @mousemove="withFacesVisible()" @mouseleave="withFacesNotVisible()">-->
                  <img class="tm-img-icon tm-img-part" src="/img/icons/Users_group.svg" width="30" height="30" alt="" @mousemove="withFacesVisible()" @mouseleave="withFacesNotVisible()">
                </div>
              </div>
            </div>

            <!--Список фукнции-->
            <div v-if="getFaceInfo(name).deleted_at === null" class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-functions-grid" data-uk-grid>
              <!--строка функции-->
              <div v-for="(faceValue, index, rowIndex) in  value" :key="faceValue.worker">
                <div  v-if="(index != 'order_super_function' && index != 'order_silver_super_function' && index != 'order_subscription_super_function')  || (!faceValue.hasOwnProperty('deleted') && faceValue.deleted === false)">
                  <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle" data-uk-grid
                       data-uk-height-match="target: > div > div">
                    <div class="uk-width-expand">
                      <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle tm-functions-grid-row" data-uk-height-match="target: > div > div" data-uk-grid>
                        <!--1 номер фукнции по-порядку-->
                        <div class="uk-width-auto 1">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="tm-function-order-num">
                              {{ rowIndex + 1 }}
                            </div>
                          </div>
                        </div>
                        <!--2 - иконка-->
                        <div class="uk-width-auto 2">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="uk-width-1-1">
                              <img v-if="faceValue.icon" class="tm-img-icon" :src="faceValue.icon" width="30" height="30" alt="">
                              <img v-else class="tm-img-icon" src="/img/images.png" width="30" height="30" alt="">
                            </div>
                          </div>
                        </div>
                        <!--3 - статусы-->
                        <div class="uk-width-medium 3"
                             v-if="faceValue.capacity && (isNotEmptyStr(faceValue.capacity) || isNotEmptyStr(faceValue.capacity_color))">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="uk-width-1-1">
                              <div class="tm-status" :class="faceValue.capacity_color && faceValue.capacity_color !== '' && faceValue.capacity_color !== 'null' ? faceValue.capacity_color : 'tm-status-custom'">
                                {{ faceValue.capacity }}
                              </div>
                              <!--                          <div class="tm-status tm-status-red" v-else-if="!isLink(faceValue.capacity_color) && faceValue.capacity_color === 'tm-status-red'">
                                                          {{ faceValue.capacity }}
                                                        </div>
                                                        <div class="tm-status" v-else-if="!isLink(faceValue.capacity) && faceValue.capacity_color === 'tm-status-green'">
                                                          {{ faceValue.capacity }}
                                                        </div>
                                                        <div class="tm-status-custom" v-else-if="faceValue.capacity_color && !isLink(faceValue.capacity)">
                                                          {{ faceValue.capacity }}
                                                        </div>-->
                              <div class="tm-status-custom" v-if="!isLink(faceValue.text) && faceValue.text !== '' ">
                                {{ faceValue.text }}
                                <span class="material-icons" style="cursor: pointer"
                                      v-if="faceValue.text && faceValue.text.length > 0"
                                      @click="openGoogleTranslate(faceValue.text)">translate</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--4 - название фукнции-->
                        <div class="4" :class="[isNotEmptyStr(faceValue.capacity) || isNotEmptyStr(faceValue.text) ? 'uk-width-expand' : 'uk-width-medium']">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="uk-width-1-1">
                              {{ faceValue.RU }}
                              <span v-if="faceValue.multiplier >= 2"
                                    :data-uk-tooltip="'title:' + local_page_keys.multiplier_tooltip"
                                    class="tm-status tm-status-small">
                                  x{{ faceValue.multiplier }}
                                </span>
                              <div class="tm-status-custom" v-if="!isLink(faceValue.text) && faceValue.text !== '' ">
                                {{ faceValue.text }}
                                <span class="material-icons" style="cursor: pointer"
                                      v-if="faceValue.text && faceValue.text.length > 0"
                                      @click="openGoogleTranslate(faceValue.text)">translate</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--5 - Скачать-->
                        <div class="uk-width-small 5" v-if="faceValue.example_file">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div v-if="typeof (faceValue.example_file) === 'object'" class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   v-for="url of  faceValue.url_example" :key="url.value">
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div
                                    v-if="!downloading || (downloading && !downloadingUrl.includes(url)) && downloadingUrl.length == 0">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 1"
                                      @click="downLoadExamplefile(url, (index + '_example'))">
                                    {{ local_page_keys.label_instructions_button_download }}
                                  </a>
                                </div>
                                <div
                                    v-else-if="(downloading && !downloadingUrl.includes(url) && downloadingUrl.length > 0)">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 2"
                                      @click="showAlert">
                                    {{ local_page_keys.label_instructions_button_download }}
                                  </a>
                                </div>
                                <div v-else>
                                  <v-progress-circular
                                      :width="2"
                                      indeterminate
                                      style="color: forestgreen"
                                  ></v-progress-circular>
                                </div>
                              </div>
                            </div>
                            <div v-else-if="faceValue.example_file && faceValue.example_file !== ''"
                                 class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"

                                   style="cursor: pointer">
                                <div>
                                  <img
                                      @mouseenter="zonephoto( '/img/images.png', faceValue.example_file)"
                                      @mouseleave="zonephotoLeave(faceValue.example_file)"
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div
                                    v-if="!downloading || (downloading && !downloadingUrl.includes(faceValue.example_file)) && downloadingUrl.length == 0">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 3"
                                      @click="downLoadExamplefile(faceValue.example_file, (index + '_example'))">
                                    {{ local_page_keys.label_instructions_button_download }}
                                  </a>
                                </div>
                                <div
                                    v-else-if="(downloading && !downloadingUrl.includes(faceValue.example_file) && downloadingUrl.length > 0)">
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset 4"
                                      @click="showAlert">
                                    {{ local_page_keys.label_instructions_button_download }}
                                  </a>
                                </div>
                                <div v-else>
                                  <v-progress-circular
                                      :width="2"
                                      indeterminate
                                      style="color: forestgreen"
                                  ></v-progress-circular>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--6 - Зона-->
                        <div class="uk-width-small 6" v-if="faceValue.client_file">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div v-if="typeof (faceValue.client_file) === 'object'" class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   @mouseenter="zonephoto(url)"
                                   @mouseleave="zonephotoLeave()"
                                   style="cursor: pointer"
                                   v-for="url of  faceValue.client_file"
                                   :key="url.value">
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div>
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset"
                                      @click="showPhotoDialog(url)">
                                    {{ local_page_keys.label_instructions_area }}</a>
                                </div>
                              </div>
                            </div>
                            <div
                                v-else-if="faceValue.client_file && faceValue.client_file !== '' && faceValue.client_file !== 'url' "
                                class="uk-width-1-1">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   @mouseenter="zonephoto(faceValue.client_file)"
                                   @mouseleave="zonephotoLeave()"
                                   style="cursor: pointer">
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div>
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset"
                                      @click="showPhotoDialog(faceValue.client_file)">
                                    {{ local_page_keys.label_instructions_area }}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div class="uk-width-1-1"
                                 v-if="faceValue.client_file && faceValue.client_file !== '' && downloadingFunctions.includes(index)">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center">

                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt="">
                                </div>
                                <div>
                                  <a
                                      :href="faceValue.client_file"
                                      target="_blank"
                                      class="tm-link-underline tm-link-reset 1"
                                  >
                                    {{ local_page_keys.label_instructions_button_download }}
                                  </a>
                                </div>
                              </div>

                            </div>

                          </div>
                        </div>
                        <!--7 -Цветные заметки-->
                        <div class="uk-width-auto" v-if="faceValue.color_notes && faceValue.color_notes.image">
                          <div class="uk-padding-small uk-flex uk-flex-middle">
                            <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                 @mousemove="zonephoto(faceValue.color_notes.image)"
                                 @mouseleave="zonephotoLeave()"
                                 style="cursor: pointer"
                            >
                              <div>
                                <img
                                    class="tm-img-icon tm-img-part"
                                    src="/img/icons/Face/File.svg"
                                    width="30" height="30" alt=""
                                >
                              </div>
                              <div>
                                <a
                                    href="javascript:void(0);"
                                    class="tm-link-underline tm-link-reset"
                                    @click="showColorNotesDialog(faceValue.color_notes)"
                                >
                                  {{ local_page_keys.label_instructions_area }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--8 - инфо-->
                    <div class="uk-width-auto 7">
                      <div class="uk-padding-small uk-text-center uk-flex uk-flex-middle">
                        <div class="uk-width-1-1">
                          <a href="#" class="md-simple" @click="info(faceValue)"><span
                              class="material-icons">feedback</span></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--диалоговое окно "главное фото до with faces"-->
    <md-dialog
      class="tm-gal-dialog"
      :md-active.sync="showDialog10"
      :md-closed="true"
      :md-clicked-outside="true"
      :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page uk-text-center">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog10 = false">
          <span class="material-icons">close</span>
        </a>
        <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
          <img v-if="modal_photo !== null"
               class="alter-photo"
               :src="modal_photo"
               alt="">
          <img v-else
               class="alter-photo"
               src="/img/images.png"
               alt="">
        </div>
        <div  v-if="false && (appVersion.indexOf('1.11.12') > -1 || appVersion.indexOf('1.11.11 (168)') > -1)" class="uk-inline-clip uk-transition-toggle tm-block-img 4">
          <div
              :style="order_photo_before_url_style">

          </div>
          <img v-if="modal_photo_before !== null" class="main-photo" :src="modal_photo_before" alt="">
          <img v-else src="/img/images.png" class="main-photo" alt="">
        </div>
      </div>
    </md-dialog>
    <!--диалоговое окно c цветными метками-->
    <ColorNotesDialog
      :modalColorNotesData="modalColorNotesData"
      :showDialog11="showDialog11"
      @hide="showDialog11 = false"/>
    <!--иифо диалоговое окно-->
    <FunctionInfoDialog
      :name="info_name"
      :text="info_text"
      :video="info_video"
      :show="showDialog"
      :items="items"
      :function_name="info_function_name"
      :showDialogFaceValue="computedFaceValue"
      @hide="showDialog = false"/>
    <!--диалоговое окно "Галерея примеров"-->
    <FunctionGalleryDialog
      :currentIndex="currentExampleCarouselIndex"
      :parent_function_name="info_function_name"
      :show="showDialog6"
      :items="items"
      :showDialogFaceValue="computedFaceValue"
      @hide="showDialog6 = false"
      @catchOnHide="handleHideEvent"
    />
  </div>
</template>
<script>
import FunctionInfoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionInfoDialog";
import FunctionGalleryDialog from "@/pages/Dashboard/Components/Dialogs/FunctionGalleryDialog";
import DownloadExampleMixin from "@/mixins/DownloadExampleMixin";
import ColorNotesDialog from "@/pages/Dashboard/Components/Dialogs/ColorNotesDialog";
import LangMixin from "@/mixins/lang-mixin";

export default {
  name: "RetouchersInfoBlock",
  props: {
    main_photo_before: {
      type: String,
      require: true,
    },
    appVersion: {
      type: String,
      require: true,
    },
    resolution:{
      type: Object,
      require: true,
    },
    main_photo_before_with_faces: {
      type: String,
      require: true,
    },
    order_id: {
      type: Number,
      require: true,
    },
    education: {
      type: Number,
    },
  },
  mixins: [DownloadExampleMixin, LangMixin],
  components: {
    FunctionInfoDialog, FunctionGalleryDialog, ColorNotesDialog
  },
  data: () => ({
    createFinanceblock: true,
    loading: false,
    finance_info: [],
    faces: [],
    showDialog10: false,
    showDialog6: false,
    showDialog: false,
    modal_photo: null,
    modal_photo_before: null,
    info_name: "",
    info_function_name: "",
    info_text: "",
    info_video: "",
    timeMin: 0,
    showDialogFaceValue:{},
    items: [
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
    ],
    retoucher_earned_and_not_paid_yet: 0,
    retoucher_earned_today: 0,
    minusTimer: null,
    timerValue: 0,
    timerMinutes: 0,
    timerMinusMinutes: 0,
    timerSeconds: 0,
    timerMinusSeconds: 0,
    fullPrice: 0,
    statusClass: '',
    interval: null,
    baseUrl: '',
    currentExampleCarouselIndex: 0,
    facesOrderSuperFunction: {},
    functionCounter: 1,
    hoverLeaveExample: {},
    showDialog11: false,
    modalColorNotesData: null,
    classDisplay: '',
    downloadingFunctions: [
      'order_change_background',
      'order_photo_frame',
      'order_individual_retouch',
      'order_swap_faces',
      'order_individual_face_retouch',
      'order_individual_add_object',
      'order_individual_background_retouch',
      'order_body_individual_retouch',
    ],
    facesInfo: []
  }),

  methods: {
    handleHideEvent(payload){
      if ('parent_function_obj' in payload && payload.parent_function_obj
          &&  Object.keys( payload.parent_function_obj).length > 0) {
       this.info( payload.parent_function_obj)
      }
    },
    setFunctionCounter() {
      return this.functionCounter++;
    },
    getOrderSuperFunction() {
      let filterKey;
      let filterName;
      const facesObjFiltered = Object.fromEntries(
          Object.entries(this.faces).filter(([key, value]) => {
                let filtered = {};
                ['order_super_function', 'order_silver_super_function', 'order_subscription_super_function'].forEach(function (name) {
                  if (value.hasOwnProperty(name)) {
                    filterKey = key;
                    filterName = name;
                    filtered = value[name];
                  }
                });
                return Object.keys(filtered).length > 0;
              }
          ));
      if (filterKey in facesObjFiltered && filterName in facesObjFiltered[filterKey]) {
        this.facesOrderSuperFunction = facesObjFiltered[filterKey][filterName];
      }
    },

    async fetchOrderInfoBlock() {
      try {
        this.loading = true;
        this.$emit('loading', true)
        await this.$store.dispatch("order/financeBlockForRetoucher", {order_id: this.order_id});
        let data = await this.$store.getters['order/financeBlockForRetoucher'];
        /* eslint-disable no-console */
        /* eslint-enable no-console */
        if (data && data.status !== 'error') {
          if (typeof (data) !== 'string') {
            let amount = 0;
            this.retoucher_earned_and_not_paid_yet = data.retoucher_earned_and_not_paid_yet ? data.retoucher_earned_and_not_paid_yet.replace(',', '') : amount.toFixed(2);
            this.retoucher_earned_today = data.retoucher_earned_today ?? amount.toFixed(2);
            if (this.retoucher_earned_and_not_paid_yet.includes(',')) {
              this.retoucher_earned_and_not_paid_yet = this.retoucher_earned_and_not_paid_yet.replace(',', '')
            }
            if (this.retoucher_earned_today.includes(',')) {
              this.retoucher_earned_today = this.retoucher_earned_today.replace(',', '')
            }
            this.$emit('order_cost_credits', data.order_cost_credits);
            this.finance_info = data.finance_select;
            // this.faces = data.order_info_block.order_functions;
            this.timerValue = Object.keys(data).includes('timer') ? data.timer : null;
            this.timerMinutes = Math.abs(this.timerValue) < 60 ? 0 : (Math.abs(this.timerValue) - Math.abs(this.timerValue % 60)) / 60;
            if (this.timerValue < 0) this.timerMinutes = 0 - this.timerMinutes;
            this.timerSeconds = Math.abs(this.timerValue % 60);
            if (this.timerValue < 0) {
              this.timerMinusMinutes = Math.abs(this.timerMinutes);
              this.timerMinusSeconds = this.timerSeconds;
            }
            this.fullPrice = Number(data.finance_select.additional_services) + Number(data.finance_select.basic_tarif);
            // this.$emit('faces', this.faces);
          }
          this.loading = false;
          this.$emit('loading', false)
        } else {
          this.createFinanceblock = false;
          this.errors = this.local_page_keys.alert_failed_infoBlock;
          this.loading = false;
          this.$emit('loading', false)
        }
      } catch (e) {
        this.createFinanceblock = false;
        this.loading = false;
        this.$emit('loading', false)
        alert(e);
      }
    },

    async zonephoto(url, example = false) {
      if (example) {
        if (example in this.hoverLeaveExample) delete this.hoverLeaveExample[example];
        let getUrl = await this.downloadImgData(example);
        if (getUrl && 'path_img_tiny' in getUrl && 'path_img_tiny_exists' in getUrl && getUrl.path_img_tiny_exists) {
          url = getUrl.path_img_tiny;
        }
      }
      if (!(example in this.hoverLeaveExample)) {
        if (url) url = url.replace('dl=0', 'raw=1');
        this.$emit('zone_photo', url);
        this.$emit('zone-visible', true);
        this.$emit('after-visible', false);
      }
    },

    zonephotoLeave(example) {
      if (example) this.hoverLeaveExample[example] = true;
      this.$emit('zone_photo', null);
      this.$emit('zone-visible', false);
      this.$emit('after-visible', true);
    },

    withFacesVisible() {
      this.$emit('with-faces-visible', true)
      this.$emit('after-visible', false);
    },
    withFacesNotVisible() {
      this.$emit('with-faces-visible', false)
      this.$emit('after-visible', true);
    },
    showPhotoDialog(url) {
      let redoneUrl = '';
      if (url && typeof (url) === 'string') {
        redoneUrl = url.replace('dl=0', 'raw=1');
      }
      this.modal_photo = (url && redoneUrl !== '') ? redoneUrl : this.main_photo_before_with_faces;
      this.modal_photo_before =  this.main_photo_before;
      this.showDialog10 = true;
    },
    showAlert() {
      alert(this.local_page_keys.alert_wait_until_the_previous_files_are_downloaded);
    },
    info(faceValue) {
      this.$nextTick( () => {
        this.showDialogFaceValue = faceValue;
        this.info_name = faceValue.RU;
        this.info_function_name = faceValue.name;
        this.info_text = faceValue.instruction_text;
        this.info_video = faceValue.videos;
        this.items = faceValue.links;
        this.showDialog = true;
      })
    },
    timercount() {
      if (!this.loading && this.timerMinutes !== null) {
        if (this.timerMinutes >= 0) {
          this.timerSeconds -= 1;
          if (this.timerSeconds < 0) {
            this.timerValue -= 1;
            this.timerMinutes -= 1;
            this.timerSeconds = 59;
          }
        }
        if (this.timerMinutes < 0) {
          this.statusClass = 'tm-status tm-status-red';
          this.minusTimer = '-'
          this.timerMinusSeconds += 1;
          if (this.timerMinusSeconds >= 60) {
            this.timerValue -= 1;
            this.timerMinusMinutes += 1;
            this.timerMinusSeconds = 0;
          }
        } else if (this.minusTimer === null && this.fullPrice !== 0 && this.timerMinutes / this.fullPrice <= 0.5) {
          this.statusClass = 'tm-status tm-status-orange';
        } else {
          this.statusClass = 'tm-status';
        }
      }
    },
    isNotEmptyStr(str) {
      return typeof str == 'string' && str !== '';
    },
    async fetchFunctionsList() {
      await this.$store.dispatch('order/orderFunctionsBlock', {order_id: this.order_id})
      let data = this.$store.getters['order/orderFunctionsBlock'];

      this.faces = typeof data !== 'string' ? data.order_functions : null;
      this.facesInfo =  data.faces_info;
      this.$emit('faces', this.faces);
      this.getOrderSuperFunction();
    },
    isLink(data) {
      let str = '';

      if (data && data !== '') {
        str = data;
      }

      return str.includes('.com');
    },

    async downloadImgData(example) {
      await this.$store.dispatch('loading/setLoading', true);
      // this.logDownloadFile(example);
      await this.$store.dispatch("order/downloadExample", 'get_only_links_' + example);
      await this.$store.dispatch('loading/setLoading', false);
      this.getterKey++;
      return await this.$store.getters['order/downloadExample'](this.getterKey);
    },
    async logDownloadFile(filename) {
      let params = {
        'filename': filename,
        'order_id': this.order_id,
      }
      await this.$store.dispatch('order/logDownloadFile', params);
    },
    showColorNotesDialog(data) {
      this.modalColorNotesData = data
      this.showDialog11 = true;
    },
    getFaceName(value) {
      return value > 0 ? this.local_page_keys.label_instructions_face + ' ' + value + ':' : this.local_page_keys.common;
    },
    getFaceInfo(face) {
      let faceInfo = this.facesInfo.find(element => element.face === String(face));
      if(typeof faceInfo != 'undefined' && 'deleted_at' in faceInfo){
        return faceInfo;
      } else {
        return {deleted_at:null};
      }
      //return this.facesInfo.find(element => element.face === String(face))
    },
  },
  computed:{
    computedFaceValue(){
      return this.showDialogFaceValue;
    },
    computedAppVersion(){
      return this.appVersion;
    },
    order_photo_before_url_style(){

      let style = 'position: absolute;' +
          'background-color: #b62626;' +
          'aspect-ratio: '+this.aspectRatio+';' +
          'bottom: 0;' +
          'top: 50%;' +
          'left: 50%;' +
          'transform: translate(-50%, -50%);' +
          'width: max-content;height: 100%;' +
          'opacity: 0.5;' +
          'background-image: url('+this.modal_photo+');' +
          'background-position: 50%;' +
          'background-size: cover;';
      let dim = this.resolution.order_photo_before_url.height > this.resolution.order_photo_before_url.width ? 'height:100%; width: max-content;': 'width:100%; height: max-content;';


      // let style = 'position: absolute;' +
      //     'background-color: #b62626;' +
      //     'aspect-ratio: '+this.aspectRatio+';' +
      //     'bottom: 0;' +
      //     'top: 50%;' +
      //     'left: 50%;' +
      //     'transform: translate(-50%, -50%);' +
      //     'width: max-content;height: 100%;' +
      //     'opacity: 0.5;' +
      //     'background-image: url('+this.modal_photo+');';
      //
      if('order_photo_before_url' in this.resolution
          && 'width' in this.resolution.order_photo_before_url
          && 'height' in this.resolution.order_photo_before_url
          && this.resolution.order_photo_before_url.height / this.resolution.order_photo_before_url.width > 2){

        return style +
            'background-size: 155%;' +
            'background-position-x: calc(50% - -20%);' +
            'background-position-y: calc(50% - 57%);';
      }
      // if('order_photo_before_url' in this.resolution
      //     && 'width' in this.resolution.order_photo_before_url
      //     && 'height' in this.resolution.order_photo_before_url
      //     && this.resolution.order_photo_before_url.width / this.resolution.order_photo_before_url.height > 1
      //     && this.resolution.order_photo_before_url.width / this.resolution.order_photo_before_url.height < 2){
      //
      //   return style +
      //       'background-size: auto;' +
      //       'background-position-x: calc(50% - 0%);' +
      //       'background-position-y: calc(50% - 0%);';
      // }
      // if('order_photo_before_url' in this.resolution
      //     && 'width' in this.resolution.order_photo_before_url
      //     && 'height' in this.resolution.order_photo_before_url
      //     && this.resolution.order_photo_before_url.width / this.resolution.order_photo_before_url.height >= 2){
      //
      //   return style +
      //       'background-size: 40%;' +
      //       'background-position-x: calc(50% - 0%);' +
      //       'background-position-y: calc(50% - 0%);';
      // }
      // return style + 'background-position: 50%;' +
      //     'background-size: cover;';
      return style + dim;
    },
    aspectRatio(){
      if('order_photo_before_url' in this.resolution
          && 'width' in this.resolution.order_photo_before_url
          && 'height' in this.resolution.order_photo_before_url
      ){
        return ' ' + this.resolution.order_photo_before_url.width + '/' + this.resolution.order_photo_before_url.height;
      }
      return '';
    },
  },
  mounted() {
    if (this.education != 1) {
      this.interval = setInterval(() => {
        this.timercount();
      }, 1000);
    }
  },

  async created() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    await this.fetchOrderInfoBlock();
    await this.fetchFunctionsList();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  }
}

</script>